import {openDB, idb} from 'idb';

import JavascriptHelpers from '../components/lib/Javascript/JavascriptHelpers';
import ServiceDataResponse from '../models/ServiceDataResponse';
import ServiceResponse from '../models/ServiceResponse';

const DB_NAME = "obsImgDb";
const DEFAULT_OBJECT_STORE = "obsImage";

// indexes e.g. {field: "offlineId", name: "offlineId", unique: true}
export default class LocalQueuedDbService
{
    constructor()
    {
        this.defaultObjectStore = DEFAULT_OBJECT_STORE;
        this.dbName = DB_NAME;
        this.indexes = [
            {field: "imageId", name: "imageId", unique: true}
        ]
        this.idb = {
            db: openDB(DB_NAME, 1,{  
                upgrade: (db, oldVersion, newVersion, transaction) => {
                    switch(oldVersion)
                    {
                        case 0:
                            
                             const store = db.createObjectStore(DEFAULT_OBJECT_STORE) 
                             if (this.indexes)
                             {
                                this.indexes.forEach((i) => {
                                    store.createIndex(i.field, i.name, {unique: i.unique} )
                                })
                             }
                            // fall through so that we can upgrade.
                        case 1:
                            break;
                        default:
                            console.log("unknown db version");
                    }

                }
            })
        };
    }






    async addImage(gcid, dataUri, imageId)
    {
        try
        {
            (await this.idb.db).add(DEFAULT_OBJECT_STORE, dataUri, imageId);
            return ServiceResponse.toServiceResponse("Image added", false);
        }
        catch(e)
        {
            msgs = new Array(e.message);
            msgs.unshift("Problem adding Image.");
            return ServiceResponse.toServiceResponse(msgs, true);
        }

    }


    async hasImage(gcid, imageId)
    {
        try
        {
            var resultData = await (await this.idb.db).get(DEFAULT_OBJECT_STORE, imageId);
            var hasImage = (typeof(resultData) != 'undefined' && resultData != null)
            return ServiceDataResponse.toServiceDataResponse(hasImage, "Image " + imageId + " fetched.", false);
        }
        catch(e)
        {
            msgs =  new Array(e.message);
            msgs =new Array(e.message);
            msgs.unshift("Problem fetching Image by id " + imageId + ". ");
            return ServiceDataResponse.toServiceDataResponse(null, msgs, true);
        }
    }

    async fetchImage(gcid, imageId)
    {
        try
        {
            var resultData = await (await this.idb.db).get(DEFAULT_OBJECT_STORE, imageId);
            return ServiceDataResponse.toServiceDataResponse(resultData, "Image " + imageId + " fetched.", false);
        }
        catch(e)
        {
            var msgs = new Array(e.message);
            msgs.unshift("Problem fetching Image by id " + imageId + ". ");
            return ServiceDataResponse.toServiceDataResponse(null, msgs, true);
        }
    }

    async deleteImage(imageId)
    {
        try
        {
            var result = await (await this.idb.db).delete(DEFAULT_OBJECT_STORE, imageId);   
            return ServiceResponse.toServiceResponse("Image " + imageId + " removed successfully.", false); 
        }
        catch(e)
        {
            var msgs = new Array(e.message);
            msgs.unshift("Problem removing Image " + imageId + ". ", true);
            return ServiceDataResponse.toServiceDataResponse(null, msgs, true);
        }

    }



}



